import { useEffect, useState } from 'react';
import '../css/animations.css';

export default function Loader() {
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setDone(true), 2000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={`amko-loader${done ? ' done' : ''}`}>
      <div className="loader-inner">
        <img src="/logo.png" alt="AMKO" className="loader-logo" />
        <div className="loader-sub">Creative Marketing · Erbil, Kurdistan</div>
      </div>
    </div>
  );
}
